import { defineFetch } from 'resift';

export default defineFetch({
  displayName: 'Get Mappings Attributes',
  make: (sourceId: string) => ({
    key: [sourceId],
    request: () => ({ http }) =>
      http({
        method: 'GET',
        route: `/sources/${sourceId}/mapping-attributes`,
      }),
  }),
});
